<template>
  <a-modal
    :title="title"
    :width="1000"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 6 },wrapperCol: { span: 14 },}" ref="ruleForm" :rules="rules">
        <!-- <a-form-model-item
          prop="moduleCode"
          label="所属模块">
          <div>
            <a-button icon="plus" type="primary" @click="formModuleAdd">添加模块</a-button>
          </div>
          <a-row :gutter="20" v-for="(formModule,index) in formModuleList">
            <a-col :span="12">
              <a-select  v-model='formModule.moduleCode'  placeholder='请选择模块'  showSearch :filterOption="filterOption">
                <a-select-option :value='item.code' :key="item.id" v-for="item in moduleList">{{item.name}}</a-select-option>
              </a-select>
            </a-col>
            <a-col :span="10">
              <a-input-number placeholder='请输入推荐值'  v-model="formModule.score" :max="5"  :min="0" :step="0.5" :precision="1" style="width: 100%"/>
            </a-col>
            <a-col :span="2">
              <a-button size="small" icon="delete" type="primary" @click="formModuleDelete(index)"></a-button>
            </a-col>
          </a-row>
        </a-form-model-item> -->
        <a-form-model-item
            prop="name"
          label="问卷中文名称">
          <a-input placeholder="请输入问卷中文名称" v-model="model.name" />
        </a-form-model-item>
<!--        <a-form-model-item-->
<!--            prop="code"-->
<!--          label="问卷编码" v-show="false">-->
<!--          <a-input placeholder="请输入问卷编码" v-model="model.code" />-->
<!--        </a-form-model-item>-->
        <a-form-model-item
            :rules="[{ required: true,message:'请输入内容', validator: dummyValidator }]"
          label="问卷英文名称">
          <a-input placeholder="请输入问卷英文名称" v-model="model.nameEn" />
        </a-form-model-item>
        <a-form-model-item
          :rules="[{ required: true,message:'请输入内容', validator: dummyValidator }]"
          help="输入关键字后，敲击回车键"
          label="问卷关键词">
          <a-select mode="tags" @change="keywordChange" v-model='model.keywordList' placeholder='请选择' >
            <a-select-option :value='item' :key="item" v-for="item in model.keywordList">{{item}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          :rules="[{ required: true,message:'请输入内容', validator: dummyValidator }]"
          label="问卷功能">
          <a-textarea :rows="2" placeholder="请输入问卷功能" v-model="model.useInfo" />
        </a-form-model-item>
        <a-form-model-item
          :rules="[{ required: true,message:'请输入内容', validator: dummyValidator }]"
          label="问卷问题数量">
          <a-input-number v-model="model.number" :min="0" :precision="1" style="width: 100%" placeholder="请问卷问题数量" />
        </a-form-model-item>
        <a-form-model-item
            :rules="[{ required: true,message:'请输入内容', validator: dummyValidator }]"
          label="预计用时（分钟）">
          <a-input-number v-model="model.useTime" :min="0" :precision="1" style="width: 100%" placeholder="请输入预计用时（分钟）" />
        </a-form-model-item>
        <a-form-model-item
          prop="scale"
          label="是否为量表">
          <a-radio-group v-model="model.scale">
            <a-radio-button value="1">是</a-radio-button>
            <a-radio-button value="0">否</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          prop="abb"
          label="问卷简称">
          <a-input placeholder="请输入问卷简称" v-model="model.abb" />
        </a-form-model-item>
        <a-form-model-item
          prop="description"
          label="问卷简要简介">
          <a-textarea :rows="2" placeholder="请输入问卷简要简介" v-model="model.intro" />
        </a-form-model-item>
        <a-form-model-item
          prop="inputTip"
          label="问卷引导语">
          <a-textarea :rows="2" placeholder="请输问卷引导语" v-model="model.inputTip" />
        </a-form-model-item>
         <a-form-model-item
          prop="intro"
          label="适应症">
          <a-input placeholder="请输入适应症" v-model="model.indications" />
        </a-form-model-item>
        <a-form-model-item
          prop="intro"
          label="禁忌症">
          <a-input placeholder="请输入适应症" v-model="model.contraindications" />
        </a-form-model-item>

        <a-form-model-item
            prop="intro"
          label="适用年龄范围">
          <a-input placeholder="请输入适用年龄范围" v-model="model.ageRange" />
        </a-form-model-item>
        <a-form-model-item
          prop="intro"
          label="适用性别">
          <a-select  v-model='model.sexRange' placeholder='请选择' >
            <a-select-option :value='item.value' :key="item.value" v-for="item in sexList">{{item.text}}</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item
          prop="intro"
          label="测评方式">
          <a-select  v-model='model.testType' placeholder='请选择' >
            <a-select-option :value='item.value' :key="item.value" v-for="item in testList">{{item.text}}</a-select-option>
          </a-select>
        </a-form-model-item>
<!--        <a-form-model-item
          prop="intro"
          label="适用性别">
          <a-input placeholder="请输入适用性别" v-model="model.sexRange" />
        </a-form-model-item>-->

<!--        <a-form-model-item
          prop="intro"
          label="测评方式">
          <a-input placeholder="请输入测评方式" v-model="model.testType" />
        </a-form-model-item>-->

        <a-form-model-item
          label="是否推荐使用访谈方式进行">
          <a-radio-group v-model="model.isVisit">
            <a-radio-button value="1">是</a-radio-button>
            <a-radio-button value="0">否</a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item
          label="是否要求非文盲">
          <a-radio-group v-model="model.isIlliteracy">
            <a-radio-button value="1">是</a-radio-button>
            <a-radio-button value="0">否</a-radio-button>
          </a-radio-group>
        </a-form-model-item>


      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { httpAction,getAction } from '@/api/manage'
import baseRules from '@/constants/baseRules'
  export default {
    name: "TempConfigFormModal",
    data () {
      return {
        title:"操作",
        visible: false,
        model: {
          keywordList:[],
        },
        sexList:[
          {text:'女',value:'0'},
          {text:'男',value:'1'},
          {text:'均可',value:'2'},
        ],
        testList:[
          {text:'自评',value:'0'},
          {text:'他评',value:'1'},
          {text:'均可',value:'2'},
        ],
        moduleList:[],
        rules:{
          name:[baseRules.required],
          //name_en: [{ required: true},{validator: dummyValidator}],
          code:[baseRules.required],
          useTime:[baseRules.required],
          scale:[baseRules.requiredChange],
          keywordList:[baseRules.requiredChange],
          // moduleCode:[baseRules.required],
        },
        confirmLoading: false,
        formModuleList:[],
        url: {
          add: "/tempconfig/tempConfigForm/add",
          edit: "/tempconfig/tempConfigForm/edit",
        },
      }
    },
    created () {
      this.loadModuleData()
    },
    methods: {
      loadModuleData(){
        getAction('/tempconfig/tempConfigModule/listAll').then(res=>{
          if(res.success){
            this.moduleList = res.result
          }
        })
      },
      keywordChange(){
        this.$set(this.model,'keyword',this.model.keywordList.join(','))
      },
      add () {
        this.edit({
          scale:'0',
          keywordList:[],
        });
      },
      edit (record) {
        this.formModuleList = record.formModuleList ? JSON.parse(record.formModuleList) : []
        this.model = Object.assign({}, record);
        this.visible = true;
        this.model = Object.assign({
          keywordList:record.keyword?record.keyword.split(','):[]
        }, record);
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        // if(this.formModuleList.length==0){
        //   return this.$message.warn('请输入所属模块');
        // }
        let errorMsg = ''
        this.formModuleList.forEach((item,index)=>{
          if(!item.moduleCode || (item.score ==null || item.score ==undefined)){
            errorMsg = `第(${index+1})行有未填内容`
          }
        })
        if(errorMsg){
          return this.$message.warn(errorMsg);
        }
        const that = this;
        // 触发表单验证
        this.$refs.ruleForm.validate(valid  => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = JSON.parse(JSON.stringify(this.model));
            formData.formModuleList = JSON.stringify(this.formModuleList)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
                that.close();
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          } else {
            return false;
          }
        })
      },
      formModuleAdd(){
        this.formModuleList.push({})
      },
      formModuleDelete(index){
        this.formModuleList.splice(index,1)
      },
      handleCancel () {
        this.close()
      },
      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      dummyValidator(rule, value, callback) {
        callback();
      },
    }
  }
</script>

<style lang="less" scoped>

</style>